module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "form-date-input.ddf55c90.svg";